module.exports = __webpack_public_path__ + "static/img/err.881cf79b.svg";